/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import bulb from '../../assets/bulb.svg';
import rgb from '../../assets/rgb.svg';
import dimmable from '../../assets/dimmable.svg';
import Swal from 'sweetalert2';
import thermostat from '../../assets/thermostat.svg';
import waterHeater from '../../assets/waterHeater.svg';
import blinds from '../../assets/blinds.svg';
import onSwitch from '../../assets/switch.svg';
import adjustableSwitch from '../../assets/switch2.svg';
import percentage from '../../assets/percent.svg';
import temp from '../../assets/temp.svg';
import { RiDeleteBin5Line } from 'react-icons/ri';
import co2 from '../../assets/co2.svg';
import { useEffect, useState } from 'react';
import { Box, CircularProgress, Modal, Stack } from '@mui/material';
import { HiPlus } from 'react-icons/hi';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { IoIosArrowDropdown } from 'react-icons/io';
import { BsQuestionCircleFill } from 'react-icons/bs';


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Trash2 } from 'lucide-react';
import {
  deleteSpecialAccess,
  deleteUser,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
  getAllCity,
  deleteCity,
  getSmartHomeDeviceByBNB,
  getCityWiseBnB,
  getSmartHomeRoomByBnB,
  createSmartHomeRoom,
  deleteSmartHomeRoom,
  updateSmartHomeRoom,
  getShellyDevices,
  getAllSmartThingsDevices,
  createSmartHomeDevice,
  fetchSmartThingsDevices,
  updateShellyDevices,
  updateHomeDeviceStatus,
  getSmartHomeDeviceByBNBWithAccessToken,
  smartHomeControls,
} from '../../helper/backend_helper';
import axios from 'axios';

// ----------------------------------------------------------------------

const deviceTypes = [
  {
    id: '1',
    image: bulb,
    name: 'On / Off Light',
    key: 'light',
  },
  {
    id: '2',
    image: rgb,
    name: 'RGB W',
    key: 'rgbw',
  },
  {
    id: '3',
    image: dimmable,
    name: 'Dimmable Light',
    key: 'dimmer',
  },
  {
    id: '4',
    image: thermostat,
    name: 'Thermostat',
    key: 'thermostat',
  },
  {
    id: '5',
    image: waterHeater,
    name: 'Water Heater',
    key: 'waterheater',
  },
  {
    id: '6',
    image: blinds,
    name: 'Blinds',
    key: 'blinds',
  },
  {
    id: '7',
    image: onSwitch,
    name: 'On / Off Switch',
    key: 'switch',
  },
  {
    id: '8',
    image: adjustableSwitch,
    name: 'Adjustable Switch',
    key: 'adjustableswitch',
  },
];

export default function CreateSmartHomeDevice() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bnb, accessToken } = location?.state;
  console.log(accessToken);
  console.log(bnb);
  const [isOn, setIsOn] = useState(true);
  const [provider, setProvider] = useState('');
  const [devices, setDevices] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [device, setDevice] = useState('');
  const [room, setRoom] = useState('');
  const [deviceType, setDeviceType] = useState('');
  const [name, setName] = useState('');
  const [italianName, setItalianName] = useState('');
  const [minTemp, setMinTemp] = useState(0);
  const [maxTemp, setMaxTemp] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [activeStartDate, setActiveStartDate] = useState('');
  const [deviceStatus, setDeviceStatus] = useState({});
  const [gpsRange, setGpsRange] = useState(0);
  const [scanLoading, setScanLoading] = useState(false);
  const [deviceData, setDeviceData] = useState(null);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(1);
  const [selectedKey, setSelectedKey] = useState('');
  const [control, setControl] = useState('user');
  console.log(control);
  console.log(selectedKey);
  const handleClick = (key) => {
    setSelectedKey(key);
  };

  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const [selectedOption2, setSelectedOption2] = useState(null);

  const handleOptionSelect2 = (option) => {
    setSelectedOption2(option);
  };

  const options = ['Manual', 'Schedule', 'Always ON', 'Always OFF'];
  // State to hold multiple schedules
  const [schedules, setSchedules] = useState([]);

  // Handle day selection for a specific schedule
  const handleDaySelect = (index, day) => {
    const newSchedules = [...schedules];
    newSchedules[index].day = day;
    setSchedules(newSchedules);
  };

  // Handle time changes
  const handleTimeChange = (index, field, value) => {
    const newSchedules = [...schedules];
    newSchedules[index][field] = value;
    setSchedules(newSchedules);
  };

  // Add new schedule
  const addNewSchedule = () => {
    setSchedules([...schedules, { day: 'Monday', startTime: '00:00', endTime: '23:00' }]);
  };

  // Delete schedule
  const deleteSchedule = (index) => {
    setSchedules(schedules.filter((_, i) => i !== index));
  };
  // Days of the week
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  console.log(deviceData);
  const handleStartDateChange = (e) => {
    setActiveStartDate(e.target.value); // Update state when date is selected
  };
  const [activeEndDate, setActiveEndDate] = useState('');
  const handleEndDateChange = (e) => {
    setActiveEndDate(e.target.value); // Update state when date is selected
  };

  const handleChangeDevice = (event) => {
    setDevice(event.target.value);
    const Data = devices?.find((device) => device?._id === event.target.value);
    setDeviceData(Data);
  };
  const getRooms = async () => {
    try {
      const data = {
        bnb: bnb,
      };
      console.log(data);
      const rooms = await getSmartHomeRoomByBnB(data);
      console.log(rooms);
      setRooms(rooms?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getRooms();
  }, [bnb]);

  const getDeviceStatus = async () => {
    try {
      const URL = `https://api.smartthings.com/v1/devices/${deviceData?.deviceId}/status`;
      console.log('Access Token:', accessToken);

      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      console.log('Headers:', headers);

      const response = await axios.get(URL, { headers });
      console.log('Device Status:', response.data);

      setDeviceStatus(response.data.components.main);
    } catch (error) {
      console.error('Error fetching device status:', error.response?.data || error.message);
    }
  };

  useEffect(() => {
    if (accessToken && deviceData?.deviceId) {
      getDeviceStatus();
    }
  }, [accessToken, deviceData]);

  const getDevices = async () => {
    try {
      if (provider === 'shelly') {
        const res = await getShellyDevices();
        setDevices(res?.data?.data);
      }
      if (provider === 'smartthings') {
        const res = await getAllSmartThingsDevices();
        setDevices(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDevices();
  }, [provider]);

  const handleScan = async () => {
    try {
      setScanLoading(true);
      if (provider === 'shelly') {
        await updateShellyDevices();
      }
      if (provider === 'smartthings') {
        await fetchSmartThingsDevices();
      }
      setScanLoading(false);
    } catch (error) {
      console.log(error);
      setScanLoading(false);
    }
  };

  const setDeviceOnOrOff = async (command = 'off') => {
    try {
      console.log(deviceData);
      const URL = `https://api.smartthings.com/v1/devices/${deviceData?.deviceId}/commands`;

      const headers = {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      };
      console.log(headers);
      const body = {
        commands: [
          {
            component: 'main',
            capability: 'switch',
            command: command, // Accepts "on" or "off"
          },
        ],
      };

      const response = await axios.post(URL, body, { headers });
      const data = {
        deviceStatus: command,
        lastOn: new Date().toISOString(),
      };
      const updateDeviceStatus = await updateHomeDeviceStatus(deviceData?._id, data);
      console.log('Device updated:', updateDeviceStatus.data);

      console.log('Device updated:', response.data);
    } catch (error) {
      console.log(error);
    }
  };


  console.log(selectedOption,selectedOption2)

  const handleSave = async () => {
    try {
      setLoading(true);
      console.log(device);
      const Categorydata = {
        deviceName: name,
        italianName,
        bnb: bnb,
        room,
        provider,
        smartThingDevice: provider === 'smartthings' ? device : null,
        shellyDevice: provider === 'shelly' ? device : null,
        deviceType: selectedKey,
        minTemp: +minTemp,
        maxTemp: +maxTemp,
        activeStartDate: new Date(activeStartDate),
        activeEndDate: new Date(activeEndDate),
        minutes: +minutes,
        gpsRange: +gpsRange,
        minValue: +minValue,
        maxValue: +maxValue,
        control,
        guestStayStatus:selectedOption,
        noBookingStatus:selectedOption2
      };
      console.log(Categorydata);
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createSmartHomeDevice(Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Device created successfully',
      });
      navigate(-1);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  const handleChangeDataByOnOff = async (isOn) => {
    try {
      const deviceId = devices.find(item => item._id ===device)
      const data = {
        deviceId: deviceId.deviceId,
        deviceType:selectedKey,
        on: isOn,
      };
      console.log(data);

      const res = await smartHomeControls(data);
      console.log(res);
      toast.success(`Device turned ${isOn ? 'on' : 'off'}`);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.error?.error);
    }
  };




  const handleChangeData = async (value) => {
    try {
      const deviceId = devices.find(item => item._id === device)
      let data;
      if (selectedKey === "blinds") {
        console.log("pppp");
        data = {
          position: value,
          deviceId: deviceId.deviceId,
          deviceType: selectedKey,
        };
      } 
      if (selectedKey === "dimmer") {
        console.log("zzzzz");
        data = {
          deviceId: deviceId.deviceId,
          deviceType: selectedKey,
          on: value > 0 ? true : false,
          brightness: value,
        };
      }
      console.log(data);
      const res = await smartHomeControls(data);
      console.log(res);
      toast.success(`Device turned ${value > 0 ? 'on' : 'off'}`);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.error?.error);
    }
  };

  return (
    <>
    <ToastContainer />
      <div className="bg-[#f4f4f4]  p-4">
        <Helmet>
          <title> Smart Home Devices </title>
        </Helmet>
        <div className="flex items-center gap-4 ">
          <div className="cursor-pointer" onClick={() => navigate(-1)}>
            <FaArrowLeftLong size={26} />
          </div>
          <h1 className="text-2xl font-bold text-black">Create Smart Home Device</h1>
        </div>

        <div className="flex gap-8 mt-4">
          {/* left section */}
          <div className="w-1/3">
            <div className="flex mt-8 p-1 items-center justify-center rounded-full bg-white w-full h-16 shadow-md">
              <button
                onClick={() => {
                  setIsOn(!isOn);
                  setControl(isOn ? 'admin' : 'user');
                }}
                className="relative w-full h-full items-center outline-none rounded-full transition-colors duration-300 ease-in-out focus:outline-none flex"
              >
                <div
                  className={`flex-1 z-50 flex items-center justify-center text-lg font-normal transition-colors duration-300 ${
                    isOn ? 'text-white' : 'text-black'
                  }`}
                >
                  User Control
                </div>

                <div
                  className={`absolute w-1/2 h-full rounded-full bg-[#4D56FF] shadow-md transition-transform duration-300 ease-in-out ${
                    isOn ? 'translate-x-0' : 'translate-x-full'
                  }`}
                ></div>

                <div
                  className={`flex-1 z-50 flex items-center justify-center text-lg font-normal transition-colors duration-300 ${
                    isOn ? 'text-black' : 'text-white'
                  }`}
                >
                  Admin Only
                </div>
              </button>
            </div>

            <form className="w-full mx-auto mt-6">
              <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">ACCOUNT</label>
              <div className="relative">
                <select
                  id="account"
                  value={provider}
                  onChange={(e) => setProvider(e.target.value)}
                  className="bg-white border outline-none border-none text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 pr-10 appearance-none dark:bg-white dark:border-gray-600 dark:placeholder-gray-900 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option selected>Choose a provider</option>
                  <option value="shelly">Shelly</option>
                  <option value="smartthings">Smart Things</option>
                </select>
                <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <IoIosArrowDropdown size={44} color="#D9D9D9" />
                </div>
              </div>
            </form>

            <div
              onClick={handleScan}
              className="cursor-pointer mt-8 p-1 flex mx-auto items-center justify-center rounded-full bg-[#cccccc] w-1/2 h-12"
            >
              <h className="text-black text-lg">{scanLoading ? 'Scanning...' : 'Scan Devices'}</h>
            </div>

            <form className="w-full mx-auto mt-6">
              <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">SELECT DEVICE</label>
              <div className="relative">
                <select
                  id="account"
                  value={device}
                  onChange={handleChangeDevice}
                  className="bg-white border outline-none border-none text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 pr-10 appearance-none dark:bg-white dark:border-gray-600 dark:placeholder-gray-900 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option selected>Choose a device</option>
                  {devices?.map((user) => (
                    <option key={user._id} value={user._id}>
                      {' '}
                      {user.name}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <IoIosArrowDropdown size={44} color="#D9D9D9" />
                </div>
              </div>
            </form>

            <form className="w-full mx-auto mt-6">
              <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">SELECT ROOM</label>
              <div className="relative">
                <select
                  id="account"
                  value={room} // This will be an array
                  onChange={(e) => setRoom(e.target.value)}
                  className="bg-white border outline-none border-none text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 pr-10 appearance-none dark:bg-white dark:border-gray-600 dark:placeholder-gray-900 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option selected>Choose a Room</option>
                  {rooms?.map((user) => (
                    <option key={user._id} value={user._id}>
                      {' '}
                      {user.name}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <IoIosArrowDropdown size={44} color="#D9D9D9" />
                </div>
              </div>
            </form>

            <form className="w-full mx-auto mt-6">
              <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">
                DEVICE NAME (ENGLISH)
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                //   value={name}
                className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                //   onChange={(e) => setName(e.target.value)}
              />
            </form>
            <form className="w-full mx-auto mt-6">
              <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">
                DEVICE NAME (ITALIAN)
              </label>
              <input
                type="text"
                //   value={name}
                value={italianName}
                onChange={(e) => setItalianName(e.target.value)}
                className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                //   onChange={(e) => setName(e.target.value)}
              />
            </form>

            <div className="flex mx-auto justify-center items-center gap-2 mt-6">
              <BsQuestionCircleFill size={20} />
              <p className="text-black font-bold">How to setup</p>
            </div>

            {provider === 'shelly' ? (
              <div className="mt-4">
                <p className="text-black">Category: {deviceData?.category}</p>
                <p className="text-black">Channel: {deviceData?.channel}</p>
                <p className="text-black">Cloud online: {deviceData?.cloud_online}</p>
                <p className="text-black">Device ID: {deviceData?.deviceId}</p>
                <p className="text-black">Mode: {deviceData?.mode}</p>
                <p className="text-black">Name: {deviceData?.name}</p>
                <p className="text-black">Pin Lock: {deviceData?.pin_lock}</p>
                <p className="text-black">Position: {deviceData?.position}</p>
                <p className="text-black">Room ID: {deviceData?.room_id}</p>
                <p className="text-black">SSID: {deviceData?.ssid}</p>
                <p className="text-black">Type: {deviceData?.type}</p>
              </div>
            ) : (
              <div className="mt-4">
                <p className="text-black">Device Id: {deviceData?.deviceId}</p>
                <p className="text-black">Device Manufacture Code: {deviceData?.deviceManufacturerCode}</p>
                <p className="text-black">label: {deviceData?.label}</p>
                <p className="text-black">Location Id: {deviceData?.locationId}</p>
                <p className="text-black">Manufacturer Name: {deviceData?.manufacturerName}</p>
                <p className="text-black">Name: {deviceData?.name}</p>
                <p className="text-black">Owner Id: {deviceData?.ownerId}</p>
                <p className="text-black">Presentational Id: {deviceData?.presentationId}</p>

                <p className="text-black">Room Id: {deviceData?.roomId}</p>
              </div>
            )}
          </div>

          {/* right section */}
          <div className="w-2/3">
            <div className="grid grid-cols-4 gap-5">
              {deviceTypes?.map((user) => (
                <div
                  onClick={() => handleClick(user.key)}
                  key={user.id}
                  className={`flex flex-col border-[3px] h-32 gap-3 p-3 items-center rounded-3xl justify-center bg-white cursor-pointer transition-all ${
                    selectedKey === user.key ? 'border-[#4D56FF]' : 'border-none'
                  }`}
                >
                  <img src={user.image} alt={user.name} className="w-10 h-10 object-cover" />
                  <div>
                    <h1 className="text-base font-normal text-black">{user.name}</h1>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex gap-4">
              <div className="w-1/2">
                {selectedKey === 'adjustableswitch' || selectedKey === 'blinds' || selectedKey === 'dimmer' ? (
                  <div>
                    <form className="w-full mx-auto mt-6">
                      <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">
                        SET MINIMUM VALUE 0-99 ( Default 0 )
                      </label>
                      <input
                        value={minValue}
                        onChange={(e) => setMinValue(e.target.value)}
                        type="number"
                        className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </form>
                    <form className="w-full mx-auto mt-6">
                      <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-900">
                        SET MAXIMUM VALUE 1-100 ( Default 100 )
                      </label>
                      <input
                        type="number"
                        value={maxValue}
                        onChange={(e) => setMaxValue(e.target.value)}
                        className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </form>

                    <div className="flex items-center mt-6 justify-around">
                      <div onClick={() => handleChangeData(100)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 100%
                        </span>
                      </div>
                      <div onClick={() => handleChangeData(90)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 90%
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center mt-3 justify-around">
                      <div onClick={() => handleChangeData(80)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 80%
                        </span>
                      </div>
                      <div onClick={() => handleChangeData(70)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 70%
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center mt-3 justify-around">
                      <div onClick={() => handleChangeData(60)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 60%
                        </span>
                      </div>
                      <div onClick={() => handleChangeData(50)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 50%
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center mt-3 justify-around">
                      <div onClick={() => handleChangeData(40)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 40%
                        </span>
                      </div>
                      <div onClick={() => handleChangeData(30)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 30%
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center mt-3 justify-around">
                      <div onClick={() => handleChangeData(20)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 20%
                        </span>
                      </div>
                      <div onClick={() => handleChangeData(10)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 10%
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center mt-3 justify-around">
                      <div onClick={() => handleChangeData(0)} className="flex gap-2 cursor-pointer">
                        <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                          Test 0%
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className=" flex items-center justify-around">
                      <p className="text-sm">CHANNEL TO OPERATE</p>
                      <form className="w-44">
                        <div className="relative">
                          <select
                            id="account"
                            className="bg-white text-center  border outline-none border-none text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 pr-10 appearance-none dark:bg-white dark:border-gray-600 dark:placeholder-gray-900 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          >
                            <option value="0">0</option>
                            <option value="1">1</option>
                          </select>
                          <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                            <IoIosArrowDropdown size={44} color="#D9D9D9" />
                          </div>
                        </div>
                      </form>
                    </div>

                    {selectedKey === 'thermostat' ? (
                      <div className="flex items-center mt-6 justify-around">
                        <div onClick={() => setDeviceOnOrOff('on')} className="flex gap-2 cursor-pointer">
                          <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                            Test ON
                          </span>
                        </div>
                        <div onClick={() => setDeviceOnOrOff('off')} className="flex gap-2 cursor-pointer">
                          <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                            Test OFF
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center mt-6 justify-around">
                        <div onClick={() => handleChangeDataByOnOff(true)} className="flex gap-2 cursor-pointer">
                          <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                            Test ON
                          </span>
                        </div>
                        <div onClick={() => handleChangeDataByOnOff(false)} className="flex gap-2 cursor-pointer">
                          <span className="bg-[#4D56FF] w-44 text-center text-white text-[16px] font-thin   py-2 rounded-full dark:bg-blue-900 dark:text-blue-300">
                            Test OFF
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {selectedKey === 'light' ||
                selectedKey === 'waterheater' ||
                selectedKey === 'switch' ||
                selectedKey === 'adjustableswitch' ||
                selectedKey === 'blinds' ||
                selectedKey === 'dimmer' ? (
                  <div className="cursor-pointer mt-8 p-1 flex mx-auto items-center justify-center rounded-full bg-[#cccccc] w-1/2 h-12">
                    <h className="text-black text-lg">Link to another device</h>
                  </div>
                ) : (
                  <div className="flex justify-center mt-8 items-center space-x-6 text-black">
                    <div className="flex items-center space-x-1 font-semibold">
                      <img src={percentage} alt="img" className="w-6 h-6 object-cover" />
                      <span className="text-black text-3xl font-bold">56%</span>
                    </div>

                    <div className="flex items-center space-x-1 font-semibold">
                      <img src={temp} alt="img" className="w-6 h-6 object-cover" />
                      <span className="text-black text-3xl font-bold">
                        {deviceStatus?.thermostatHeatingSetpoint?.heatingSetpoint?.value}°C
                      </span>
                    </div>

                    <div className="flex items-center space-x-1 font-semibold">
                      <img src={co2} alt="img" className="w-6 h-6 object-cover" />
                      <span className="text-black text-3xl font-bold">247</span>
                      <span className="text-black text-xs font-bold">PPM</span>
                    </div>
                  </div>
                )}

                {selectedKey === 'light' ||
                selectedKey === 'waterheater' ||
                selectedKey === 'switch' ||
                selectedKey === 'adjustableswitch' ||
                selectedKey === 'blinds' ||
                selectedKey === 'dimmer' ? (
                  <div className="flex mx-auto justify-center items-center gap-2 mt-6">
                    <BsQuestionCircleFill size={20} />
                    <p className="text-black font-bold">How to automatically turn the lights off</p>
                  </div>
                ) : (
                  <div className="flex mx-auto justify-center items-center gap-2 mt-6">
                    <BsQuestionCircleFill size={20} />
                    <p className="text-black font-bold">How to create a thermostat</p>
                  </div>
                )}
              </div>
              {selectedKey === 'light' ||
              selectedKey === 'waterheater' ||
              selectedKey === 'switch' ||
              selectedKey === 'adjustableswitch' ||
              selectedKey === 'blinds' ||
              selectedKey === 'dimmer' ? (
                <div className="w-1/2 mt-2">
                  {/* DURING GUEST STAY - First Section */}
                  <label className="block mb-1 text-sm font-medium text-gray-900 ">DURING GUEST STAY</label>
                  <div className="flex gap-8">
                    {options.slice(0, 2).map((option) => (
                      <div
                        key={option}
                        onClick={() => handleOptionSelect(option)}
                        className={`cursor-pointer mt-4 p-1 flex items-center justify-center rounded-full bg-white w-full h-12 transition-all ${
                          selectedOption === option ? 'border-[3px] border-[#4D56FF]' : 'border border-transparent'
                        }`}
                      >
                        <span className="text-black text-lg">{option}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex gap-8">
                    {options.slice(2, 4).map((option) => (
                      <div
                        key={option}
                        onClick={() => handleOptionSelect(option)}
                        className={`cursor-pointer mt-4 p-1 flex items-center justify-center rounded-full bg-white w-full h-12 transition-all ${
                          selectedOption === option ? 'border-[3px] border-[#4D56FF]' : 'border border-transparent'
                        }`}
                      >
                        <span className="text-black text-lg">{option}</span>
                      </div>
                    ))}
                  </div>

                  {/* DURING GUEST STAY - Second Section */}
                  <label className="block mb-1 mt-10 text-sm font-medium text-gray-900 ">NO BOOKING</label>
                  <div className="flex gap-8">
                    {options.slice(0, 2).map((option) => (
                      <div
                        key={option + '-second'}
                        onClick={() => handleOptionSelect2(option)}
                        className={`cursor-pointer mt-4 p-1 flex items-center justify-center rounded-full bg-white w-full h-12 transition-all ${
                          selectedOption2 === option ? 'border-[3px] border-[#4D56FF]' : 'border border-transparent'
                        }`}
                      >
                        <span className="text-black text-lg">{option}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex gap-8">
                    {options.slice(2, 4).map((option) => (
                      <div
                        key={option + '-second'}
                        onClick={() => handleOptionSelect2(option)}
                        className={`cursor-pointer mt-4 p-1 flex items-center justify-center rounded-full bg-white w-full h-12 transition-all ${
                          selectedOption2 === option ? 'border-[3px] border-[#4D56FF]' : 'border border-transparent'
                        }`}
                      >
                        <span className="text-black text-lg">{option}</span>
                      </div>
                    ))}
                  </div>

                  <div className="mt-10 flex flex-col items-center">
                    <p className="text-black font-bold mb-2 text-xl">SCHEDULE</p>

                    {/* Render multiple schedules */}
                    {schedules.map((schedule, index) => (
                      <div
                        key={index}
                        className="flex flex-col border border-black w-full rounded-3xl items-center space-x-2 p-4 gap-4 mb-4"
                      >
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center space-x-2">
                            {days.map((day) => (
                              <button
                                key={day}
                                onClick={() => handleDaySelect(index, day)}
                                className={`w-10 h-10 rounded-full text-sm font-medium bg-white text-black ${
                                  schedule.day === day ? 'border-[3px] border-[#4D56FF]' : ''
                                }`}
                              >
                                {day.charAt(0).toUpperCase()}
                              </button>
                            ))}
                          </div>
                          <div
                            onClick={() => deleteSchedule(index)}
                            className="flex items-center justify-center w-10 h-10 rounded-full bg-[#FF9D9D] cursor-pointer"
                          >
                            <RiDeleteBin5Line size={22} />
                          </div>
                        </div>

                        <div className="flex items-center gap-2 justify-between w-full">
                          <form className="w-full">
                            <div className="relative">
                              <select
                                value={schedule.startTime}
                                onChange={(e) => handleTimeChange(index, 'startTime', e.target.value)}
                                className="bg-white text-center border outline-none border-none text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 pr-10 appearance-none"
                              >
                                {Array.from({ length: 24 }, (_, i) => {
                                  const time = `${i.toString().padStart(2, '0')}:00`;
                                  return (
                                    <option key={time} value={time}>
                                      {time}
                                    </option>
                                  );
                                })}
                              </select>
                              <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                                <IoIosArrowDropdown size={44} color="#D9D9D9" />
                              </div>
                            </div>
                          </form>

                          <p className="text-black">TO</p>

                          <form className="w-full">
                            <div className="relative">
                              <select
                                value={schedule.endTime}
                                onChange={(e) => handleTimeChange(index, 'endTime', e.target.value)}
                                className="bg-white text-center border outline-none border-none text-gray-900 text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full p-3.5 pr-10 appearance-none"
                              >
                                {Array.from({ length: 24 }, (_, i) => {
                                  const time = `${i.toString().padStart(2, '0')}:00`;
                                  return (
                                    <option key={time} value={time}>
                                      {time}
                                    </option>
                                  );
                                })}
                              </select>
                              <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                                <IoIosArrowDropdown size={44} color="#D9D9D9" />
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    ))}

                    {/* Add new schedule button */}
                    <div
                      onClick={addNewSchedule}
                      className="cursor-pointer mt-2 p-1 flex mx-auto items-center justify-center rounded-full border border-black w-full h-12"
                    >
                      <HiPlus size={20} />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-1/2">
                  <form className="w-full mx-auto mt-6">
                    <label className="block mb-1 text-sm font-medium text-gray-900 ">ENABLE FROM</label>
                    <div className="relative">
                      <input
                        type="date"
                        value={activeStartDate}
                        onChange={handleStartDateChange}
                        className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                  </form>

                  <form className="w-full mx-auto mt-2">
                    <label className="block mb-1 text-sm font-medium text-gray-900 ">ENABLE TO</label>
                    <div className="relative">
                      <input
                        type="date"
                        value={activeEndDate}
                        onChange={handleEndDateChange}
                        className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                  </form>

                  <form className="w-full mx-auto mt-2">
                    <label className="block mb-1 text-sm font-medium text-gray-900 ">MINIMUM TEMPERATURE CONTROL</label>
                    <input
                      type="number"
                      value={minTemp}
                      onChange={(e) => setMinTemp(e.target.value)}
                      //   value={name}
                      className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      //   onChange={(e) => setName(e.target.value)}
                    />
                  </form>
                  <form className="w-full mx-auto mt-2">
                    <label className="block mb-1 text-sm font-medium text-gray-900 ">MAXIMUM TEMPERATURE CONTROL</label>
                    <input
                      type="number"
                      value={maxTemp}
                      onChange={(e) => setMaxTemp(e.target.value)}
                      //   value={name}
                      className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      //   onChange={(e) => setName(e.target.value)}
                    />
                  </form>
                  <form className="w-full mx-auto mt-2">
                    <label className="block mb-1 text-sm font-medium text-gray-900 ">
                      AUTOMATICALLY TURNS OFF AFTER (MINUTES)
                    </label>
                    <input
                      type="number"
                      value={minutes}
                      onChange={(e) => setMinutes(e.target.value)}
                      //   value={name}
                      className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      //   onChange={(e) => setName(e.target.value)}
                    />
                  </form>
                  <form className="w-full mx-auto mt-2">
                    <label className="block mb-1 text-sm font-medium text-gray-900 ">GPS RANGE (METERS)</label>
                    <input
                      type="number"
                      value={gpsRange}
                      onChange={(e) => setGpsRange(e.target.value)}
                      //   value={name}
                      className="w-full  p-3.5 outline-none bg-white   text-sm border border-none rounded-full focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      //   onChange={(e) => setName(e.target.value)}
                    />
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-center  items-center gap-5">
          <div onClick={handleSave} className="flex gap-2 cursor-pointer">
            <span className="bg-[#4D56FF] w-52 text-center text-white text-[16px] font-thin   py-1 rounded-2xl dark:bg-blue-900 dark:text-blue-300">
              {loading ? <CircularProgress color="inherit" size={16} /> : 'Save'}
            </span>
          </div>
          {/* <div className="flex gap-2 cursor-pointer">
            <span className="bg-[#cccccc] w-52 text-center text-black text-[16px] font-thin   py-1 rounded-2xl dark:bg-blue-900 dark:text-blue-300">
              Delete Device
            </span>
          </div> */}
        </div>
      </div>
    </>
  );
}
